<template>
  <router-view></router-view>
</template>

<script>
export default {
  // Admin acts as a nested-router wrapper; child routes render their own layouts.
  name: 'admin',
};
</script>
